import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { ClinicEnvironment, ENVIRONMENT } from 'environments';

export class SessionExtendEndpoint {
  private env = inject<ClinicEnvironment>(ENVIRONMENT);
  private httpClient = inject(HttpClient);

  put() {
    return this.httpClient.put<void>(`${this.env.constants.api_url}users/me/session/`, {});
  }
}
